"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _KeyInsightCard = require("./KeyInsightCard");

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _utils = require("./utils");

var _DashboardDateRangeFilter = _interopRequireDefault(require("./DashboardDateRangeFilter"));

var _QueryParameters = _interopRequireDefault(require("./QueryParameters"));

var _AlertComponent = _interopRequireDefault(require("@insided/shared/uikit/AlertComponent"));

var _TopSearchesTable = _interopRequireDefault(require("./TopSearchesTable"));

var _FrequentSearchesWithoutResultTable = _interopRequireDefault(require("./FrequentSearchesWithoutResultTable"));

var _TopSearchResultsTable = _interopRequireDefault(require("./TopSearchResultsTable"));

var _searchAnalyticsTransformer = require("./searchAnalyticsTransformer");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Key Insight Card Configuration
var KEY_INSIGHT_CONFIG = [{
  metric: 'user_count',
  loadingState: 'isLoadingUserCount',
  title: 'Total Users',
  titleTooltip: 'The total number of unique users who performed at least one search during the selected time period.',
  stateKey: 'totalUsers',
  isPercentage: false
}, {
  metric: 'search_count',
  loadingState: 'isLoadingSearchCount',
  title: 'Total Searches',
  titleTooltip: 'The total number of search queries performed during the selected time period.',
  stateKey: 'totalSearches',
  isPercentage: false
}, {
  metric: 'no_result_rate',
  loadingState: 'isLoadingNoResultRate',
  title: 'No Results Rate',
  titleTooltip: 'The percentage of searches that returned zero results during the selected time period.',
  stateKey: 'noResultsRate',
  isPercentage: true
}, {
  metric: 'conversion_rate',
  loadingState: 'isLoadingConversionRate',
  title: 'Conversion Rate',
  titleTooltip: 'The percentage of searches where users clicked a search result and stayed on the clicked page for more than 30 seconds during the selected time period.',
  stateKey: 'conversionRate',
  isPercentage: true
}, {
  metric: 'click_through_rate',
  loadingState: 'isLoadingClickThroughRate',
  title: 'Click-through Rate',
  titleTooltip: 'The percentage of searches that resulted in at least one click on a search result during the selected time period.',
  stateKey: 'clickThroughRate',
  isPercentage: true
}, {
  metric: 'no_click_rate',
  loadingState: 'isLoadingNoClickRate',
  title: 'No Clicks Rate',
  titleTooltip: 'The percentage of searches where users did not click on any search result during the selected time period.',
  stateKey: 'noClicksRate',
  isPercentage: true
}];
/**
 * Minimum date for search analytics data.
 * Data is only available from January 13, 2026 onwards.
 */

var SEARCH_ANALYTICS_MIN_DATE = new Date('2026-01-13');

var SearchAnalyticsDashboard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchAnalyticsDashboard, _Component);

  var _super = _createSuper(SearchAnalyticsDashboard);

  function SearchAnalyticsDashboard(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SearchAnalyticsDashboard);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addHandler", function () {
      var isDateRangeOpen = _this.state.isDateRangeOpen;

      if (isDateRangeOpen) {
        window.document.addEventListener('mousedown', _this.handleClickOutside);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeHandler", function () {
      window.document.removeEventListener('mousedown', _this.handleClickOutside);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      if (!_this.wrapperRef) return;

      if (!_this.wrapperRef.contains(e.target)) {
        _this.onResetDateRange();

        _this.setState({}, _this.removeHandler);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDateRange", function (value) {
      _this.setState({
        isDateRangeOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPresetDateRangeChanged", function (selectedDate) {
      _this.setState({
        selectedPresetDateRangeId: selectedDate.id,
        selectedDate: selectedDate
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCustomDateRangeChanged", function (dates) {
      // Ensure dates are not before the minimum date
      var adjustedStartDate = dates[0] < SEARCH_ANALYTICS_MIN_DATE ? SEARCH_ANALYTICS_MIN_DATE : dates[0];
      var adjustedEndDate = dates[1] < SEARCH_ANALYTICS_MIN_DATE ? SEARCH_ANALYTICS_MIN_DATE : dates[1];
      var customSelectedDate = {
        id: 'custom_range',
        label: 'Custom Range',
        startDate: adjustedStartDate,
        endDate: adjustedEndDate
      };

      _this.setState({
        selectedDate: customSelectedDate,
        selectedPresetDateRangeId: customSelectedDate.id
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDateRangeChanged", function () {
      _this.setState(function (prevState) {
        var selectedDate = prevState.selectedDate,
            selectedPresetDateRangeId = prevState.selectedPresetDateRangeId;

        var updatedState = _objectSpread(_objectSpread({}, prevState.storedState), {}, {
          presetDateRangeId: selectedPresetDateRangeId,
          selectedDateRange: selectedDate
        });

        var queryString = new _QueryParameters.default();
        queryString.set('date_range', selectedPresetDateRangeId);

        if (selectedPresetDateRangeId !== 'custom_range') {
          queryString.unset('date_from').unset('date_till');
        } else {
          queryString.set('date_from', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.startDate)).set('date_till', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.endDate));
        }

        window.history.pushState(null, 'date range changed', queryString.getQueryString());
        (0, _utils.updateDateRangeInSessionStorage)(selectedDate);
        return {
          isDateRangeOpen: false,
          startDate: new Date(selectedDate.startDate),
          endDate: new Date(selectedDate.endDate),
          storedState: updatedState
        };
      }, function () {
        _this.loadKeyInsightMetrics();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetDateRange", function () {
      _this.setState(function (prevState) {
        var _prevState$storedStat = prevState.storedState,
            presetDateRangeId = _prevState$storedStat.presetDateRangeId,
            selectedDateRange = _prevState$storedStat.selectedDateRange;
        return {
          isDateRangeOpen: false,
          selectedPresetDateRangeId: presetDateRangeId,
          selectedDate: selectedDateRange
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "makeAnalyticsApiRequest", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
        var group,
            sortingOptions,
            widgetType,
            _this$state,
            startDate,
            endDate,
            filterOptions,
            _args = arguments;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                group = _args.length > 1 && _args[1] !== undefined ? _args[1] : '';
                sortingOptions = _args.length > 2 ? _args[2] : undefined;
                widgetType = _args.length > 3 ? _args[3] : undefined;
                _this$state = _this.state, startDate = _this$state.startDate, endDate = _this$state.endDate;
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDateForUrl(startDate),
                  end: _AnalyticsDateFormatter.default.formatDateForUrl(endDate)
                };

                if (group !== '') {
                  Object.assign(filterOptions, {
                    group: group
                  });
                }

                if (sortingOptions) {
                  Object.assign(filterOptions, sortingOptions);
                }

                if (widgetType) {
                  Object.assign(filterOptions, {
                    widgetType: widgetType
                  });
                }

                _context.next = 10;
                return _axios.default.post(url, filterOptions);

              case 10:
                return _context.abrupt("return", _context.sent);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchMetricData", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(metric, loadingStateKey, apiEndpoint, apiParams) {
        var response;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Set loading state to true
                _this.setState((0, _defineProperty2.default)({}, loadingStateKey, true));

                _context2.prev = 1;
                _context2.next = 4;
                return _this.makeAnalyticsApiRequest(apiEndpoint, '', apiParams !== null && apiParams !== void 0 ? apiParams : {}, metric);

              case 4:
                response = _context2.sent;

                // Process and update state with fetched data
                _this.updateStateWithFetchedData([{
                  metric: metric,
                  data: response.data,
                  success: true
                }]);

                _context2.next = 12;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](1);
                console.error("Failed to fetch ".concat(metric, ":"), _context2.t0); // Mark metric as having no data when fetch fails

                _this.setState(function (prevState) {
                  return {
                    hasMetricData: _objectSpread(_objectSpread({}, prevState.hasMetricData), {}, (0, _defineProperty2.default)({}, metric, false))
                  };
                });

              case 12:
                _context2.prev = 12;

                // Clear loading state
                _this.setState((0, _defineProperty2.default)({}, loadingStateKey, false));

                return _context2.finish(12);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 8, 12, 15]]);
      }));

      return function (_x2, _x3, _x4, _x5) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "loadKeyInsightMetrics", function () {
      // Fetch each metric independently
      KEY_INSIGHT_CONFIG.forEach(function (_ref3) {
        var metric = _ref3.metric,
            loadingState = _ref3.loadingState;

        _this.fetchMetricData(metric, loadingState, '/analyticsV2/searchAnalyticsKeyInsights');
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateStateWithFetchedData", function (results) {
      var stateUpdates = {};
      var hasMetricDataUpdates = {};
      results.forEach(function (result) {
        var config = KEY_INSIGHT_CONFIG.find(function (c) {
          return c.metric === result.metric;
        });
        if (!config) return;

        var value = _this.extractMetricValue(result, config); // hasData is true if we successfully extracted a value (not null)
        // extractMetricValue returns null when there's no data in the response


        var hasData = value !== null;

        if (value !== null) {
          stateUpdates[config.stateKey] = value;
        } // Track whether this metric has data available


        hasMetricDataUpdates[config.metric] = hasData;
      }); // Update state with all collected data

      if (Object.keys(stateUpdates).length > 0 || Object.keys(hasMetricDataUpdates).length > 0) {
        _this.setState(function (prevState) {
          return _objectSpread(_objectSpread({}, stateUpdates), {}, {
            hasMetricData: _objectSpread(_objectSpread({}, prevState.hasMetricData), hasMetricDataUpdates)
          });
        });
      }
    });

    var _getStartAndEndDate = (0, _utils.getStartAndEndDate)(),
        initialStartDate = _getStartAndEndDate.initialStartDate,
        initialEndDate = _getStartAndEndDate.initialEndDate,
        initalDateRangeId = _getStartAndEndDate.initalDateRangeId;

    var queryParams = new _QueryParameters.default(); // Get dates from URL params or defaults, then ensure they're not before the minimum date

    var rawStartDate = queryParams.has('date_from') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_from')) : initialStartDate;
    var rawEndDate = queryParams.has('date_till') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_till')) : initialEndDate;

    var _adjustedStartDate = rawStartDate < SEARCH_ANALYTICS_MIN_DATE ? SEARCH_ANALYTICS_MIN_DATE : rawStartDate;

    var _adjustedEndDate = rawEndDate < SEARCH_ANALYTICS_MIN_DATE ? SEARCH_ANALYTICS_MIN_DATE : rawEndDate;

    _this.setState({
      selectedPresetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
      storedState: {
        presetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
        selectedDateRange: (0, _utils.getDefaultSelectedDate)()
      },
      startDate: _adjustedStartDate,
      endDate: _adjustedEndDate,
      presetDateRangeList: [],
      isDateRangeOpen: false,
      isLoading: false,
      messageType: null,
      message: '',
      clickThroughRate: 0,
      noClicksRate: 0,
      conversionRate: 0,
      totalSearches: 0,
      noResultsRate: 0,
      totalUsers: 0,
      isLoadingSearchCount: true,
      isLoadingUserCount: true,
      isLoadingNoResultRate: true,
      isLoadingNoClickRate: true,
      isLoadingClickThroughRate: true,
      isLoadingConversionRate: true,
      hasMetricData: {}
    });

    return _this;
  }

  (0, _createClass2.default)(SearchAnalyticsDashboard, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this2 = this;

        var presetDateRanges, filteredPresetDateRanges, defaultDateRange, _this$state2, storedState, selectedPresetDateRangeId, today, fallbackStartDate, fallbackEndDate, _dateRangeForDisplay, dateFrom, dateTill, selectedDateRange, selectedPresetId, updatedState, adjustedDateFrom, adjustedDateTill;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                (0, _utils.trackDashboardUsage)('search-analytics-dashboard');
                _context3.prev = 1;
                _context3.next = 4;
                return SearchAnalyticsDashboard.fetchDateRangeFilter();

              case 4:
                presetDateRanges = _context3.sent;
                // Filter out preset date ranges that start before the minimum date
                filteredPresetDateRanges = presetDateRanges.filter(function (preset) {
                  var presetStartDate = new Date(preset.startDate);
                  return presetStartDate >= SEARCH_ANALYTICS_MIN_DATE;
                });
                defaultDateRange = (0, _utils.getDefaultDateRange)(filteredPresetDateRanges, this.state.selectedPresetDateRangeId);
                _this$state2 = this.state, storedState = _this$state2.storedState, selectedPresetDateRangeId = _this$state2.selectedPresetDateRangeId; // Handle case where no preset date ranges are available (e.g., all filtered out)
                // Use current date as end date and min date as start date

                if (defaultDateRange) {
                  _context3.next = 14;
                  break;
                }

                today = new Date();
                fallbackStartDate = SEARCH_ANALYTICS_MIN_DATE;
                fallbackEndDate = today < SEARCH_ANALYTICS_MIN_DATE ? SEARCH_ANALYTICS_MIN_DATE : today;
                this.setState({
                  isLoading: false,
                  presetDateRangeList: filteredPresetDateRanges,
                  startDate: fallbackStartDate,
                  endDate: fallbackEndDate
                }, function () {
                  _this2.loadKeyInsightMetrics();
                });
                return _context3.abrupt("return");

              case 14:
                _dateRangeForDisplay = (0, _utils.dateRangeForDisplay)(storedState, defaultDateRange, selectedPresetDateRangeId), dateFrom = _dateRangeForDisplay.dateFrom, dateTill = _dateRangeForDisplay.dateTill, selectedDateRange = _dateRangeForDisplay.selectedDateRange, selectedPresetId = _dateRangeForDisplay.selectedPresetId, updatedState = _dateRangeForDisplay.updatedState; // Ensure dates are not before the minimum date

                adjustedDateFrom = dateFrom < SEARCH_ANALYTICS_MIN_DATE ? SEARCH_ANALYTICS_MIN_DATE : dateFrom;
                adjustedDateTill = dateTill < SEARCH_ANALYTICS_MIN_DATE ? SEARCH_ANALYTICS_MIN_DATE : dateTill;
                this.setState({
                  isLoading: false,
                  presetDateRangeList: filteredPresetDateRanges,
                  selectedPresetDateRangeId: selectedPresetId,
                  selectedDate: selectedDateRange,
                  startDate: adjustedDateFrom,
                  endDate: adjustedDateTill,
                  storedState: updatedState
                }, function () {
                  _this2.loadKeyInsightMetrics();
                });
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3["catch"](1);
                console.error('Error loading search analytics dashboard:', _context3.t0);
                this.setState({
                  isLoading: false
                }, function () {
                  _this2.loadKeyInsightMetrics();
                });

              case 24:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 20]]);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "extractMetricValue",
    value:
    /**
     * Extract the metric value from API response based on configuration
     * Handles both Legacy and Data Lake response formats automatically
     */
    // eslint-disable-next-line class-methods-use-this
    function extractMetricValue(result, config) {
      var _result$data;

      var data = (_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.data;
      if (!data) return null; // Use transformer to normalize the response format

      var normalizedData = (0, _searchAnalyticsTransformer.transformKeyInsightMetric)(data);
      return (0, _searchAnalyticsTransformer.extractMetricValue)(normalizedData, config.isPercentage);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state3 = this.state,
          presetDateRangeList = _this$state3.presetDateRangeList,
          isDateRangeOpen = _this$state3.isDateRangeOpen,
          selectedPresetDateRangeId = _this$state3.selectedPresetDateRangeId,
          startDate = _this$state3.startDate,
          endDate = _this$state3.endDate,
          isLoading = _this$state3.isLoading,
          selectedDate = _this$state3.selectedDate,
          messageType = _this$state3.messageType,
          message = _this$state3.message;
      var isVisibleFor = messageType === 'success' ? 5000 : false;
      return (0, _preact.h)("div", {
        className: "search-analytics-dashboard-overview dashboard-overview",
        "data-bounded-context": "Analytics",
        "data-entity": "search-analytics-dashboard"
      }, messageType ? (0, _preact.h)(_AlertComponent.default, {
        messageType: messageType,
        message: message,
        sticky: true,
        renderHTML: true,
        isVisibleFor: isVisibleFor
      }) : null, (0, _preact.h)(_header.default, {
        title: "Search Analytics Dashboard",
        disableCancelButton: true,
        disableSaveButton: true
      }), (0, _preact.h)("div", {
        className: "filter-container"
      }, (0, _preact.h)("div", {
        ref: function ref(node) {
          _this3.wrapperRef = node;
        }
      }, (0, _preact.h)(_DashboardDateRangeFilter.default, {
        isLoading: isLoading,
        startDate: startDate,
        endDate: endDate,
        isDropdownOpen: isDateRangeOpen,
        items: presetDateRangeList,
        selectedDate: selectedDate,
        selectedPresetId: selectedPresetDateRangeId,
        toggleDropdown: this.toggleDateRange,
        onChange: this.onDateRangeChanged,
        onReset: this.onResetDateRange,
        onCustomDateChange: this.onCustomDateRangeChanged,
        onPresetDateChange: this.onPresetDateRangeChanged,
        showMonths: 2,
        minDate: SEARCH_ANALYTICS_MIN_DATE,
        "data-element-name": "date range filter",
        "data-track-type": "click"
      }))), (0, _preact.h)("div", {
        className: "metric-container"
      }, KEY_INSIGHT_CONFIG.map(function (config) {
        var _this3$state$hasMetri;

        var isLoading = _this3.state[config.loadingState]; // If loading is complete and we have data status, use it; otherwise assume data available (will show 0)
        // If undefined and not loading: no data (false); if undefined and loading: wait for load (true)

        var hasData = (_this3$state$hasMetri = _this3.state.hasMetricData[config.metric]) !== null && _this3$state$hasMetri !== void 0 ? _this3$state$hasMetri : isLoading;
        var isKeyInsightAvailable = hasData;
        return (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
          key: config.metric,
          title: config.title,
          total: _this3.state[config.stateKey],
          titleTooltip: config.titleTooltip,
          isPercentage: config.isPercentage,
          isLoading: isLoading,
          isKeyInsightAvailable: isKeyInsightAvailable,
          keyInsightUnavailableMessage: "There's no data yet",
          hideComparisionWithPreviousPeriod: true
        });
      })), (0, _preact.h)("div", {
        className: "search-analytics-tables-container"
      }, (0, _preact.h)(_TopSearchesTable.default, {
        startDate: startDate,
        endDate: endDate,
        fetchData: this.makeAnalyticsApiRequest
      }), (0, _preact.h)(_FrequentSearchesWithoutResultTable.default, {
        startDate: startDate,
        endDate: endDate,
        fetchData: this.makeAnalyticsApiRequest
      }), (0, _preact.h)(_TopSearchResultsTable.default, {
        startDate: startDate,
        endDate: endDate,
        fetchData: this.makeAnalyticsApiRequest
      })), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null));
    }
  }], [{
    key: "fetchDateRangeFilter",
    value: function () {
      var _fetchDateRangeFilter = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var res;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _axios.default.get('/analyticsV2/fetchDateRangeFilter');

              case 2:
                res = _context4.sent;
                return _context4.abrupt("return", res.data.ranges);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function fetchDateRangeFilter() {
        return _fetchDateRangeFilter.apply(this, arguments);
      }

      return fetchDateRangeFilter;
    }()
  }]);
  return SearchAnalyticsDashboard;
}(_preact.Component);

var _default = SearchAnalyticsDashboard;
exports.default = _default;